import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Image, Dimmer, Loader } from "semantic-ui-react";
import BoxReviewConstants from "../../lib/boxReview/Constants";
import "./BoxReview.css";
import * as UtilMethods from "./../../utils/UtilMethods";
import * as Constants from "./../../utils/Constants";
import MessageDisplay from "./components/MessageDisplay";
import Login from "./../Login/Login";
import ErrorAlert from "./../ErrorAlert/ErrorAlert";
import SideBarMenu from "./../SideBarMenu/SideBarMenu";
import BoxErrorModal from "../BoxErrorModal/BoxErrorModal";
import RxBagVerificationModal from "./components/RxBagVerificationModal/RxBagVerificationModal";
import WrongLabelModal from "./components/WrongLabelModal/WrongLabelModal";
import OperatorConfirmModal from "../OperatorConfirmModal/OperatorConfirmModal";
import ShippingLabelVerificationModal from "./components/ShippingLabelVerificationModal/ShippingLabelVerificationModal";
import { StatePersistor } from "../../utils/StatePersistor";
import Footer from "./components/Footer";
import ContentImage from "./components/ContentImage";
import ShippingsList from "./components/ShippingsList/ShippingsList";
import CustomerDetails from "./components/CustomerDetails";
import PrintLabelConfirmationModal from "./components/PrintLabelConfirmationModal/PrintLabelConfirmationModal";
import RestartDeliveryModal from "./components/RestartDeliveryModal/RestartDeliveryModal";
import LeftoverOrders from "../LeftoverOrders/LeftoverOrders";
import ReviewEndpoints from "../../lib/review/ReviewEndpoints";
import WorkstationEndpoints from "../../lib/workstation/WorkstationEndpoints";
import { checkVersion } from "../../utils/versionCheck/versionCheck";
import MessageClientModal from "./components/BoxValidationMessageComponents/MessageClientModal";
import App from "../../App";
/*
 * REDUX ACTION IMPORTS
 */
import {
    setAppMode,
    setError,
    setShowLoader,
    setLoadingStatus,
    setLoginStatus,
} from "../../lib/store/reducers/applicationStateReducer";

import {
    clearBoxReviewState,
    setBoxReviewModel,
    setCurrentBox,
    setOrderShippingMethod,
    setBoxReviewAction,
    loadBoxReviewOrder,
    setForceAction,
    setWrongLabelModalStatus,
    setErrorData,
    switchToDelivery,
    reloadBoxReview,
} from "../../lib/store/reducers/boxReviewReducer";

import { setUser, setWorkstation } from "../../lib/store/reducers/loginInfoReducer";
import { PayloadWrapper } from "../../lib/store/types/PayloadWrapper";
import { OperatorInfoModel } from "../../lib/interfaces/Login/IOperatorInfoModel";
import { WorkstationInfoModel } from "../../lib/interfaces/Login/IWorkstationInfoModel";
import { ApplicationMode } from "../../lib/store/types/ApplicationStateTypes";

const { ActionStates } = BoxReviewConstants;

const initialState = {};

const persistedStateConfig = {
    template: {
        operatorID: -1,
        rxBagVerificationModalOpen: false,
        shippingLabelVerificationModalOpen: false,
        printedLabel: "",
        cancelOldLabel: true,
        newShippingMethod: -1,
        printLabelFromShippingID: -1,
        printLabelConfirmationModalOpen: false,
        restartDeliveryModalOpen: false,
        leftoverOrdersOpen: false,
        confirmWrongRXScan: false,
    },
    decidingKey: "operatorID",
    lifespanSeconds: 600,
    persistorPrefix: "review-",
};

class BoxReview extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...initialState,
            ...StatePersistor.restoreState(
                persistedStateConfig.template,
                persistedStateConfig.lifespanSeconds,
                persistedStateConfig.decidingKey,
                persistedStateConfig.persistorPrefix
            ),
        };
        this._signIn = this._signIn.bind(this);
        this._signOut = this._signOut.bind(this);
        this._resetArticleWeight = this._resetArticleWeight.bind(this);
        this._printLabelCopy = this._printLabelCopy.bind(this);
        this._closeInfoModal = this._closeInfoModal.bind(this);
        this._setInputFocus = this._setInputFocus.bind(this);
        this._handleClick = this._handleClick.bind(this);
        this._verifyRxBag = this._verifyRxBag.bind(this);
        this._cancelVerifyRxBag = this._cancelVerifyRxBag.bind(this);
        this.scanInput = React.createRef();
        this.mainContainer = React.createRef();
        this._verifyShippingLabel = this._verifyShippingLabel.bind(this);
        this._printNewLabel = this._printNewLabel.bind(this);
        this._openPrintLabelConfirmationModal = this._openPrintLabelConfirmationModal.bind(this);
        this._restartDelivery = this._restartDelivery.bind(this);
        this._printLabel = this._printLabel.bind(this);
        this._versionCheckPoll = this._versionCheckPoll.bind(this);
    }

    _savePersistedState(template, state, prefix) {
        let stateMatch = {};
        Object.keys(template).forEach((key) => (stateMatch[key] = state[key]));
        StatePersistor.insertState(stateMatch, prefix);
    }

    componentDidMount() {
        this._versionCheckPoll();
    }

    componentDidUpdate(prevProps, prevState) {
        this._savePersistedState(persistedStateConfig.template, this.state, persistedStateConfig.persistorPrefix);

        const { loading, loggedIn } = this.props.appState;
        const { boxReviewAction, wrongLabelModalOpen } = this.props.boxReviewState;

        let {
            rxBagVerificationModalOpen,
            shippingLabelVerificationModalOpen,
            printLabelConfirmationModalOpen,
            restartDeliveryModalOpen,
        } = this.state;
        let rxBagVerificationModalClosed = !rxBagVerificationModalOpen && prevState.rxBagVerificationModalOpen;
        let shippingLabelVerificationModalClosed =
            !shippingLabelVerificationModalOpen && prevState.shippingLabelVerificationModalOpen;
        let wrongLabelModalClosed = !wrongLabelModalOpen && prevProps.boxReviewState.wrongLabelModalOpen;
        let printLabelConfirmationModalClosed =
            !printLabelConfirmationModalOpen && prevState.printLabelConfirmationModalOpen;
        let restartDeliveryModalClosed = !restartDeliveryModalOpen && prevState.restartDeliveryModalOpen;

        let modalWasClosed = [
            rxBagVerificationModalClosed,
            shippingLabelVerificationModalClosed,
            wrongLabelModalClosed,
            printLabelConfirmationModalClosed,
            restartDeliveryModalClosed,
        ].some((x) => x);
        let finishedLoading = !loading && prevProps.appState.loading;

        if ((modalWasClosed || finishedLoading) && boxReviewAction === ActionStates.LOAD_BOX && loggedIn) {
            this._setInputFocus();
        }
    }

    componentWillUnmount() {
        clearInterval(this._versionCheckInterval);
        this._signOut();
    }

    _versionCheckPoll = () => {
        this._versionCheckInterval = setInterval(checkVersion, 20000);
    };

    _handleClick() {
        if (!this.state.confirmWrongScan && !this.state.confirmWrongRXScan) {
            this._setInputFocus();
        }
    }

    _onInputKeyPress(e) {
        if (e.key !== "Enter") {
            return;
        }

        this._submitInput(e.target.value);
        e.target.value = "";
    }

    _setInputFocus() {
        this.scanInput.current.focus();
    }

    _submitInput(input) {
        this.props.clearBoxReviewState();

        let trimmedInput = input.replace(/^[bB]+/, "");
        if (trimmedInput !== ''){
            this.props.loadBoxReviewOrder(trimmedInput);
        }
    }

    _resetArticleWeight(shouldPrintCopy, hasCorrectContent) {
        const { currentBox } = this.props.boxReviewState;
        const { operatorID, workstationID } = this.props.loginState;
        this.props.forceAction(false);
        return ReviewEndpoints.resetArticleWeights(
            operatorID,
            workstationID,
            currentBox.invoice.invoiceNumber,
            currentBox.boxBarcode,
            hasCorrectContent
        )
            .then((result) => {
                if (shouldPrintCopy) {
                    this._printLabelCopy();
                }
            })
            .catch((error) => {
                alert(error);
            })
            .finally(() => {
                this._setInputFocus();
            });
    }

    _setLeftoverOrders = (state) => {
        this.setState({ leftoverOrdersOpen: state });
    };

    _closeInfoModal() {
        this.props.setBoxReviewError(false, "", "");
    }
    _printLabelCopy() {
        const { currentBox } = this.props.boxReviewState;

        const { operatorID, workstationID } = this.props.loginState;
        if (currentBox.hasRX) {
            const ipackBoxId = currentBox.iPackBox.id;
            if (ipackBoxId != null) {
                const shippingID = currentBox.shippings.filter((x) => x.iPackBoxID == ipackBoxId)[0].shippingID;
                this.setState({ rxBagVerificationModalOpen: true, printLabelFromShippingID: shippingID });
            }
        } else {
            this.props.toggleLoading(true);
            ReviewEndpoints.printShippingLabelCopy(operatorID, workstationID, currentBox.boxBarcode)
                .catch((err) => {
                    console.log(err);
                    alert(err.exceptionMessage);
                })
                .finally(() => {
                    this.props.toggleLoading(false);
                });
        }
    }

    _getRxItemsToScan(printLabelFromShippingID) {
        const { currentBox } = this.props.boxReviewState;
        let rxShippingItems = currentBox.shippings.filter((x) => x.shippingID == printLabelFromShippingID)[0].items;
        let rxItems = currentBox.invoice.items.filter((x) => x.isRX && rxShippingItems.some((z) => z.skuID == x.skuId));
        return rxItems;
    }

    _printShippingLabelNewCallback = () => {
        let rxItems = this._getRxItemsToScan(this.state.printLabelFromShippingID);
        if (rxItems.every((i) => i.isRX && i.verified)) {
            this.setState({ rxBagVerificationModalOpen: false });
            this.props.toggleLoading(true);

            this._printNewLabel();

            this._resetRxBagVerifications();
        }
    };

    _printShippingLabeCopyCallback = () => {
        const { currentBox } = this.props.boxReviewState;
        let rxItems = this._getRxItemsToScan(this.state.printLabelFromShippingID);
        if (rxItems.every((i) => i.isRX && i.verified)) {
            const { operatorID, workstationID } = this.props.loginState;

            this.setState({ rxBagVerificationModalOpen: false });
            this.props.toggleLoading(true);

            ReviewEndpoints.printShippingLabelCopy(
                operatorID,
                workstationID,
                currentBox.boxBarcode,
                currentBox.invoice.items.filter((x) => x.isRX && x.verified).map((x) => x.skuId)
            )
                .then((printedLabel) => {
                    this.setState({
                        shippingLabelVerificationModalOpen: true,
                        printedLabel,
                    });
                })
                .catch((err) => {
                    console.log(err);
                    alert(err.exceptionMessage);
                })
                .finally(() => {
                    this._resetRxBagVerifications();
                });
        }
    };

    _cancelVerifyRxBag() {
        this._resetRxBagVerifications();
        this.setState({ rxBagVerificationModalOpen: false });
    }

    _resetRxBagVerifications() {
        const { currentBox } = this.props.boxReviewState;

        currentBox.checkedCount = 0;
        currentBox.invoice.items.filter((i) => i.isRX).forEach((b) => (b.verified = false));
        this.setState({
            currentBox,
            printLabelConfirmationModalOpen: false,
        });
        this.props.toggleLoading(false);
    }

    _verifyShippingLabel(input) {
        let { printedLabel } = this.state;
        if (this._shippingLabelsTheSame(input, printedLabel) || !printedLabel) {
            this.setState({
                shippingLabelVerificationModalOpen: false,
                printedLabel: "",
            });
        } else {
            // this.setState({
            //   confirmWrongScan: true
            // })
            alert("FEL ETIKETT! FRÅGA ANSVARIG");
        }
    }

    _verifyRxBag(input) {
        const { currentBox } = this.props.boxReviewState;
        let rxItems = this._getRxItemsToScan(this.state.printLabelFromShippingID);
        var currentBoxItem = rxItems.find((i) => i.isRX && !i.verified && i.ean === input);

        if (currentBoxItem) {
            currentBoxItem.verified = true;
            currentBox.checkedCount++;
        } else {
            this.setState({
                confirmWrongRXScan: true,
            });
        }
        if (currentBox.iPackBox && !currentBox.previouslyControlled) {
            this.props.setCurrentBox(currentBox, () => this._printShippingLabeCopyCallback());
        } else {
            this.props.setCurrentBox(currentBox, () => this._printShippingLabelNewCallback());
        }
    }

    _openPrintLabelConfirmationModal(shippingMethod, cancelOldLabel, printLabelFromShippingID) {
        const { currentBox } = this.props.boxReviewState;
        let rxItems = this._getRxItemsToScan(printLabelFromShippingID);
        currentBox.toCheckCount = rxItems.length;
        currentBox.checkedCount = 0;
        this.props.setCurrentBox(currentBox, () => {
            this.setState({
                printLabelConfirmationModalOpen: true,
                printLabelFromShippingID: printLabelFromShippingID,
                newShippingMethod: shippingMethod,
                cancelOldLabel: cancelOldLabel,
            });
        });
    }

    _printLabel() {
        const { currentBox } = this.props.boxReviewState;
        if (currentBox.hasRX) {
            this.setState({ rxBagVerificationModalOpen: true });
        } else {
            this.setState({
                printLabelConfirmationModalOpen: false,
            });
            if (currentBox.iPackBox && !currentBox.previouslyControlled) {
                this._printLabelCopy();
            } else {
                this._printNewLabel();
            }
        }
    }

    _printNewLabel() {
        const { printLabelFromShippingID, newShippingMethod, cancelOldLabel } = this.state;
        const { operatorID, workstationID } = this.props.loginState;
        const { currentBox } = this.props.boxReviewState;
        this.props.toggleLoading(true);
        ReviewEndpoints.printNewLabel(
            operatorID,
            workstationID,
            printLabelFromShippingID,
            newShippingMethod,
            cancelOldLabel
        )
            .then((res) => {
                if (res !== "") {
                    this.props.setBoxReviewError(true, res, "");
                } else {
                    //TODO lägg tillbaka nedan när backend skickar med packagenumber alltid i (res)
                    // if (currentBox.hasRX) {
                    //   this.setState({
                    //     shippingLabelVerificationModalOpen: true,
                    //     printedLabel,
                    //   });
                    // }
                }
                this.props.toggleLoading(false);
            })
            .catch((err) => {
                this.props.toggleLoading(false);
                this.props.setBoxReviewError(true, err.message, "");
            });
    }

    _restartDelivery() {
        this.setState({ restartDeliveryModalOpen: false }, () => {
            this.props.switchToDeliveryMode(true);
        });
    }

    _shippingLabelsTheSame(input, printedLabel) {
        var inputUpperCase = (input || "").toUpperCase();
        var printedLabelUpperCase = (printedLabel || "").toUpperCase();

        var inputIsLabel = inputUpperCase === printedLabelUpperCase;
        var inputContainsLabel = inputUpperCase.indexOf(printedLabelUpperCase) > -1;
        var isBussgodsMatch =
            (printedLabelUpperCase.substr(0, 3) === "BUS" && printedLabelUpperCase.substr(3) === inputUpperCase) ||
            (inputUpperCase.substr(0, 3) === "BUS" && inputUpperCase.substr(3) === printedLabelUpperCase);
        var isSchenkerMatch =
            inputUpperCase.length + 1 === printedLabelUpperCase.length &&
            printedLabelUpperCase.indexOf(inputUpperCase) > -1;

        return [inputIsLabel, inputContainsLabel, isBussgodsMatch, isSchenkerMatch].some((x) => x);
    }

    // Denna körs när man loggat in
    _signIn(operator) {
        this._setWorkstationID();

        var operatorID = -1;
        var operatorName = "Okänd";
        if (typeof operator === "object") {
            operatorID = operator.operatorId;
            operatorName = operator.operatorName;
        } else {
            operatorID = operator;
        }

        this.props.setAppMode(ApplicationMode.BoxReviewMode);
        this.props.setUser(operatorID, operatorName);
        this.props.setLoginStatus(true);

        this.setState({
            operatorID,
        });
    }

    _signOut(callback) {
        if (!callback || typeof callback !== "function") {
            callback = () => {};
        }

        this.props.setLoginStatus(false);

        this.setState(
            {
                ...persistedStateConfig.template,
            },
            callback
        );
    }

    _setWorkstationID() {
        return new Promise((resolve, reject) => {
            let workstationID = UtilMethods.getParamValue("ws");

            let rejectWrap = (e) => {
                this.props.setBoxReviewError(false, "", e);
                reject();
            };

            WorkstationEndpoints.getWorkstationInformation(workstationID)
                .then((wsResult) => {
                    if (!UtilMethods.IsAcceptableWorkstationType(wsResult.workstationType)) {
                        return this._signOut(() => {
                            rejectWrap("Felaktig arbetsstation!");
                        });
                    }
                    this.props.setWorkstation(workstationID, wsResult.workstationType, wsResult.branchID);
                    return this.setState(
                        {
                            workstationID,
                            workstationType: wsResult.workstationType,
                        },
                        resolve
                    );
                })
                .catch(rejectWrap);
        });
    }

    _isRXBagEAN(input, scanInputType) {
        let isRXBag = false;
        let rxEAN = input.slice(0, 5);

        if (scanInputType === Constants.SCAN_INPUT_TYPE_EAN && parseInt(rxEAN) === 39907) {
            isRXBag = true;
        }
        return isRXBag;
    }

    _loadFromLeftOver(box) {
        this._setLeftoverOrders(false);
        this._submitInput(box);
    }

    render() {
        const {
            rxBagVerificationModalOpen,
            shippingLabelVerificationModalOpen,
            printLabelConfirmationModalOpen,
            restartDeliveryModalOpen,
        } = this.state;

        const { loading } = this.props.appState;

        const {
            currentError,
            showInfoModal,
            infoMessage,
            currentBox,
            forceAction,
            imageUrl,
            imageBytes,
            imageFound,
            labelUrl,
            shippingMethods,
        } = this.props.boxReviewState;

        const { operatorID, operatorName, branchID } = this.props.loginState;

        const isMachineNotControlled = currentBox && currentBox.iPackBox && !currentBox.previouslyControlled;
        const disableShippingPrintButton =
            (isMachineNotControlled && [2, 5].includes(currentBox.iPackBox.validationResult)) ||
            (currentBox && currentBox.partialDeliveryNotFinished);
        const restartDelivery =
            currentBox && currentBox.canRestartInvoice && currentBox.containsDeliveredItems && !isMachineNotControlled;

        const { wrongLabelModalOpen, boxReviewAction } = this.props.boxReviewState;

        if (operatorID === -1) {
            return (
                <React.Fragment>
                    <Login
                        loginCallback={this._signIn}
                        workstationID={UtilMethods.getParamValue("ws")}
                        loginView={Constants.VIEW.REVIEW}
                    />
                    <ErrorAlert error={currentError} style={{ top: "100px" }} />
                </React.Fragment>
            );
        }

        if (boxReviewAction === ActionStates.COMPLETE_BOX || boxReviewAction === ActionStates.PACK_MODE) {
            return <App></App>;
        }

        return (
            <div className="main" ref={this.mainContainer} onClick={this._handleClick}>
                <Dimmer active={loading} inverted>
                    <Loader size="big" />
                </Dimmer>
                <MessageClientModal />
                <div className="container">
                    <BoxErrorModal open={showInfoModal} message={infoMessage} onClose={this._closeInfoModal} />
                    {this.state.leftoverOrdersOpen ? (
                        <LeftoverOrders
                            open={this.state.leftoverOrdersOpen}
                            operatorID={operatorID}
                            workstationID={this.state.workstationID}
                            callback={(box) => this._loadFromLeftOver(box)}
                            onClose={() => this._setLeftoverOrders(false)}
                        ></LeftoverOrders>
                    ) : null}
                    <SideBarMenu
                        restartDelivery={
                            restartDelivery ? () => this.setState({ restartDeliveryModalOpen: true }) : null
                        }
                        clearBoxReview={() => this.props.clearBoxReviewState()}
                        logOut={this._signOut}
                        disabled={false}
                        leftoverOrders={() => this._setLeftoverOrders(true)}
                    />
                    <input
                        className={`ScanInputField ${forceAction ? "box-input-error" : ""}`}
                        autoComplete="off"
                        id="ScanInputField"
                        placeholder={forceAction ? "Stämmer innehållet?" : ""}
                        autoFocus
                        onKeyPress={(e) => this._onInputKeyPress(e)}
                        ref={this.scanInput}
                        disabled={forceAction || loading}
                    />
                    {currentBox ? (
                        <Grid columns={2}>
                            <Grid.Row>
                                <Grid.Column>
                                    {currentBox ? (
                                        <div>
                                              <MessageDisplay
                                                  currentBox={currentBox}
                                                  resetWeightCallback={this._resetArticleWeight}
                                                  imageFound={imageFound}
                                                  branchID={branchID}
                                              />
                                            <ShippingsList
                                                printShipping={
                                                    disableShippingPrintButton
                                                        ? null
                                                        : this._openPrintLabelConfirmationModal
                                                }
                                                printCopy={isMachineNotControlled}
                                                isEditable={!isMachineNotControlled}
                                                shippings={currentBox.shippings}
                                                invoiceItems={currentBox.invoice.items}
                                                shippingMethods={shippingMethods}
                                            />
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </Grid.Column>
                                <Grid.Column>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <CustomerDetails currentBox={currentBox} />
                                        {/* {UtilMethods.IsAutoPack(workstationType) && ![2, 5].includes(currentBox.iPackBox.validationResult) ?
                      <Button color={"red"} size='big' onClick={this._printLabelCopy}>Skriv ut fraktetikett</Button>
                      : ""} */}
                                        <ContentImage imageBytes={imageBytes} imageUrl={imageUrl} />
                                        {labelUrl ? <Image src={labelUrl} className="label-image" /> : ""}
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column></Grid.Column>
                                <Grid.Column></Grid.Column>
                            </Grid.Row>
                        </Grid>
                    ) : (
                        ""
                    )}
                </div>
                <Footer operatorName={operatorName} />
                <RxBagVerificationModal
                    open={rxBagVerificationModalOpen}
                    verify={this._verifyRxBag}
                    toCheckCount={(currentBox || {}).toCheckCount}
                    checkedCount={(currentBox || {}).checkedCount}
                    close={this._cancelVerifyRxBag}
                    confirmWrongRXScanOpen={this.state.confirmWrongRXScan}
                />
                <ShippingLabelVerificationModal
                    open={shippingLabelVerificationModalOpen}
                    verify={this._verifyShippingLabel}
                    confirmWrongScanOpen={this.state.confirmWrongScan}
                />
                <WrongLabelModal
                    open={wrongLabelModalOpen}
                    onClose={() => this.props.setWrongLabelModalStatus(false)}
                />
                <PrintLabelConfirmationModal
                    open={printLabelConfirmationModalOpen}
                    isMachineNotControlled={isMachineNotControlled}
                    continueCallback={this._printLabel}
                    cancelCallback={() => this.setState({ printLabelConfirmationModalOpen: false })}
                    cancelOldLabel={this.state.cancelOldLabel && !isMachineNotControlled}
                />
                <RestartDeliveryModal
                    open={restartDeliveryModalOpen}
                    continueCallback={this._restartDelivery}
                    cancelCallback={() => this.setState({ restartDeliveryModalOpen: false })}
                />
                {this.state.confirmWrongRXScan ? (
                    <OperatorConfirmModal
                        open={this.state.confirmWrongRXScan}
                        SortBoxID={this.props.boxReviewState.currentBox.boxID}
                        orderNumber={this.props.boxReviewState.currentBox.orderNumber}
                        isScanIdValidationRxRequired={true}
                        onClose={() => {
                            this.setState({
                                confirmWrongRXScan: false,
                            });
                        }}
                        reviewMode={true}
                    />
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        layout: state.layouHelpReducer,
        appState: state.applicationStateReducer,
        loginState: state.loginInfoReducer,
        boxReviewState: state.boxReviewReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    const applicationStateActions = {
        toggleLoading: (loading) => dispatch(setLoadingStatus(new PayloadWrapper(loading))),
        showLoader: (show) => dispatch(setShowLoader(show)),
        setError: (payload) => dispatch(setError(payload)),
        setLoginStatus: (status) => dispatch(setLoginStatus(new PayloadWrapper(status))),
        setAppMode: (appMode) => dispatch(setAppMode(new PayloadWrapper(appMode))),
    };

    const loginReducerActions = {
        setUser: (operatorID, operatorName) => dispatch(setUser(new OperatorInfoModel(operatorID, operatorName))),
        setWorkstation: (workstationID, workstationType, branchID) =>
            dispatch(setWorkstation(new WorkstationInfoModel(workstationID, workstationType, branchID))),
    };

    const boxReviewActions = {
        reloadBoxReview: (reload) => dispatch(reloadBoxReview(new PayloadWrapper(reload))),
        switchToDeliveryMode: (restart) => dispatch(switchToDelivery(new PayloadWrapper(restart))),
        setBoxReviewModel: (sortBox, callback) => dispatch(setBoxReviewModel({ sortBox, callback })),
        setOrderShippingMethod: (shippingMethod) =>
            dispatch(setOrderShippingMethod(new PayloadWrapper(shippingMethod))),
        setCurrentBox: (box, callback) => dispatch(setCurrentBox({ box, callback })),
        clearBoxReviewState: () => dispatch(clearBoxReviewState()),
        setBoxReviewAction: (action) => dispatch(setBoxReviewAction(new PayloadWrapper(action))),
        loadBoxReviewOrder: (input) => dispatch(loadBoxReviewOrder({ inputValue: input, switchToDelivery: true })),
        forceAction: (force) => dispatch(setForceAction(new PayloadWrapper(force))),
        setWrongLabelModalStatus: (open) => dispatch(setWrongLabelModalStatus(new PayloadWrapper(open))),
        setBoxReviewError: (showInfoModal, infoMessage, currentError) =>
            dispatch(setErrorData({ showInfoModal, infoMessage, currentError })),
    };

    return { ...applicationStateActions, ...loginReducerActions, ...boxReviewActions };
};

export default connect(mapStateToProps, mapDispatchToProps)(BoxReview);
